import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardPowerIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2.13672V12.1367M18.36 6.77672C19.6184 8.03551 20.4753 9.63916 20.8223 11.3849C21.1693 13.1307 20.9909 14.9401 20.3096 16.5845C19.6284 18.2288 18.4748 19.6343 16.9948 20.6231C15.5148 21.6119 13.7749 22.1396 11.995 22.1396C10.2151 22.1396 8.47515 21.6119 6.99517 20.6231C5.51519 19.6343 4.36164 18.2288 3.68036 16.5845C2.99909 14.9401 2.82069 13.1307 3.16772 11.3849C3.51475 9.63916 4.37162 8.03551 5.63 6.77672"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardPowerIcon;
